<script setup>
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';

import { useAccount } from 'dashboard/composables/useAccount';

import ChannelItem from 'dashboard/components/widgets/ChannelItem.vue';

const { t } = useI18n();
const router = useRouter();
const { accountId, currentAccount } = useAccount();

const globalConfig = useMapGetter('globalConfig/get');

const enabledFeatures = ref({});

// Per-account, Super Admin-only opt-in (mirrors waha_unofficial_enabled) — the
// Zernio cards only appear for accounts explicitly enabled for it.
const zernioEnabled = computed(
  () => currentAccount.value?.zernio_enabled === true
);

const channelList = computed(() => {
  const { apiChannelName } = globalConfig.value;
  // Prime Insight: exibe apenas WhatsApp, API e Telegram (+ Zernio quando habilitado).
  // Ocultos: website, facebook, instagram, sms, email, line, tiktok, voice, whatsapp_call.
  const list = [
    {
      key: 'whatsapp',
      title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.WHATSAPP.TITLE'),
      description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.WHATSAPP.DESCRIPTION'),
      icon: 'i-woot-whatsapp',
    },
    {
      key: 'api',
      title: apiChannelName || t('INBOX_MGMT.ADD.AUTH.CHANNEL.API.TITLE'),
      description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.API.DESCRIPTION'),
      icon: 'i-woot-api',
    },
    {
      key: 'telegram',
      title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.TELEGRAM.TITLE'),
      description: t('INBOX_MGMT.ADD.AUTH.CHANNEL.TELEGRAM.DESCRIPTION'),
      icon: 'i-woot-telegram',
    },
  ];

  if (zernioEnabled.value) {
    list.push(
      {
        key: 'zernio_instagram',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.ZERNIO_INSTAGRAM.TITLE'),
        description: t(
          'INBOX_MGMT.ADD.AUTH.CHANNEL.ZERNIO_INSTAGRAM.DESCRIPTION'
        ),
        icon: 'i-woot-instagram',
      },
      {
        key: 'zernio_facebook',
        title: t('INBOX_MGMT.ADD.AUTH.CHANNEL.ZERNIO_FACEBOOK.TITLE'),
        description: t(
          'INBOX_MGMT.ADD.AUTH.CHANNEL.ZERNIO_FACEBOOK.DESCRIPTION'
        ),
        icon: 'i-woot-messenger',
      }
    );
  }

  return list;
});

const initializeEnabledFeatures = async () => {
  enabledFeatures.value = currentAccount.value.features;
};

const initChannelAuth = channel => {
  const params = {
    sub_page: channel,
    accountId: accountId.value,
  };
  router.push({ name: 'settings_inboxes_page_channel', params });
};

onMounted(() => {
  initializeEnabledFeatures();
});
</script>

<template>
  <div
    class="grid max-w-3xl grid-cols-1 xs:grid-cols-2 mx-0 gap-6 sm:grid-cols-3 p-8"
  >
    <ChannelItem
      v-for="channel in channelList"
      :key="channel.key"
      :channel="channel"
      :enabled-features="enabledFeatures"
      @channel-item-click="initChannelAuth"
    />
  </div>
</template>
